import React, { FC } from 'react';
import PropTypes from 'prop-types';

const ModalContent: FC = ({ children }) => {
  return <div className="modal-body">{children}</div>;
};

ModalContent.propTypes = {
  children: PropTypes.node,
};

ModalContent.displayName = 'ModalContent';

export default ModalContent;
